export enum ShopStatus {
  Active = 'active',
  Inactive = 'inactive',
}
